/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowCircleDown: {
  name: 'arrow-circle-down';
  data: string;
} = {
  name: 'arrow-circle-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"/></svg>`
};
